import { render, staticRenderFns } from "./PollQuestions.vue?vue&type=template&id=39e63e61&scoped=true&"
import script from "./PollQuestions.vue?vue&type=script&lang=js&"
export * from "./PollQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e63e61",
  null
  
)

export default component.exports